import { Component, OnInit, OnDestroy, PipeTransform } from "@angular/core";
import { AuthService } from "../../../services/auth.service";
import { StorageService } from "../../../services/storage.service";
import $ from 'jquery';
import { Router, ActivatedRoute, } from "@angular/router";
import { PatientService } from "../../../services/patient.service";
import { GlobalService } from "../../../services/global.service";
import { ToastrService } from "ngx-toastr";
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService, SharedModule } from 'primeng/api';
import { UserService } from "../../../services/user.service";
import { Response } from "selenium-webdriver/http";
import { openClose } from "../../../animations";
import { NgbModal, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import { DomSanitizer } from "@angular/platform-browser";
import { DatePipe } from "@angular/common";
import { UtilService } from "../../../util/utilService";
import { CanComponentDeactivate } from "../../../can-deactivate.guard";
import { DoctorService } from '../../../services/doctor.service';
import { NgbDate, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import { Observable } from 'rxjs';
import { MessageService } from 'primeng/api';
import { debounceTime, distinctUntilChanged, map, pairwise } from 'rxjs/operators';
import { filter } from 'rxjs/operators';
import * as _ from "lodash";




const all_complaints = [];
const all_diagnosis = [];
const all_medicine_instructions = [];

// const all_complaints = ["Abd Pain", "Back Pain", "Bed Wetting", "Blood In Urine", "Boil", "Burning Micturation", "Burning While Urination ", "Burns", "Chest Pain", "Cold", "Crying", "Cuts", "Decresed Oral Intake", "Dental Caries", "Dizzying", "Driblling Of Urine", "Dry Cough", "Dry Cough With Expectoation", "Dry Itchy Rash", "Dry Skin", "Dysuria", "Ear Ache", "Ears Itching", "Eneuresis", "Excessive Crying ", "Exclusive Breast Feeding", "Eye Discharge", "Eye Redness", "Fever", "Fever With Chills", "Flat Feet", "Fore Skin Ballooning", "Foul Smell", "Gasses Distension", "Green Sticky Flood Mucus", "Gritting Of Teeth", "Hard Stools", "Head Banging", "Head Injury", "Headache", "Hernia", "Hydrocoel ", "Hydrocole ", "Hyperactive", "Inguinal", "Insect Bite", "Irregular Bowels", "Irritable ", "Jaundice", "Leg Pains", "Lesions  ", "Loose Motions", "Loose Weight Gain", "Maculo Papular Rash", "Mixed Feed", "Mouth Odur", "Mouth Ulcers", "Mucoid", "Nail Biting", "Nasal Blockade", "Nausea", "Neck Glands Swelling", "Nephritis Acute", "Noisy Resperation", "Nose Bleed", "Pica", "Pilo Nephritis", "Poly Urea", "Poor Appetite/ Fussy Eater", "Poor Attention Span", "Poor Consantration", "Poor Wt And Ht", "Prickly Heat", "Rash", "Rash On Face", "Recurent Infections", "Restless At Night", "Runny Nose", "Slow In School", "Sneezing", "Sore Throat", "Stomach Pain", "Strain While Urination And Motion", "Sweating ++ ", "Teeth Grinding ", "Teething", "Temper Tantrums", "Thumb Sucking", "Tongue Coated", "Tooth Ache", "Trauma", "Umblical Hernia", "Urine Albumin", "Vomitting", "Well Visit", "Wheezing"];
// const all_diagnosis = ["Abd. Colic", "Absecess", "Absescess", "Ac Gastritis", "Ac Sinusitis", "Actute Bronchitis", "Acute Gastritis", "Acute Gastroentritis", "Acute Laryngitis", "Acute Myalgia", "Acute Nephritis", "Acute Otitis Externa", "Acute Otitis Media", "Acute Otorhea", "Acute Pharyngitis", "Acute Pyoderma", "Acute Rhinitis", "Acute Tonsillitis (exudative)", "Acute Tonsillitis (pustular)", "Acute Urti", "Acute Urti, Viral", "Add/adhd/ld/autism/slow Learner", "Adenoids", "Allergic Rhinitis", "Allergy", "Amoebic Dysentry", "Anal Fissure", "Anemia", "Angiodoema", "Angioneurotic Edema", "Appendicitis", "Asthamatics", "Atopic Dermatitis", "Atypical Myco Bacterium", "Autism", "Bacillary Dysentry", "Bacteremia ", "Balanoposthitis", "Baleno Prosthesis", "Behaviral Disorders (temper Tantrunns/ Stubborn/pika)", "Bilat Thelarche", "Breast Abcess", "Breath Holding Spell", "Bronchiolicic", "Broncholitis", "Cah", "Cat Scratch Fever", "Cellulitis", "Central Precocius Puberty", "Cerebral Palsy", "Cervical Iymphadenitis", "Chicken Pox", "Chikungunia", "Childhood Asthma", "Chronic Diarrhoea", "Common Cold", "Congenital  Short Stature", "Congenital Heart Disease (acyanotic)", "Congenital Heart Disease (cyanotic)", "Congenital Horseshoe Kidney", "Conjunctivitis", "Constipation", "Contact Allergy", "Contact Dermatitis", "Cushing Syndrome", "Cystitis", "D Def", "Dandruff", "Dacryocystitis", "Dehydration", "Delayed M And M", "Dengue", "Dental Abscess", "Deviated Nasal Septum", "Df With Sec Infection", "Diaper Rash", "Diarrhoea", "Diarrhoea Drug Induce ", "Digeorge", "Dog Bite", "Downs Syndrome", "Drug Allergy", "Dry Dermatitis", "Dysentry", "Eczema", "Epilepsy", "Epispadion Pemopubic", "Epistaxis", "Epulse", "Erythema Nodosum", "Exercise Induced Asthma", "Eye Blepharitis", "Factitious Fever ", "Failure To Thrive ", "Familial Short Stature", "Faulty Food Habits", "Fecal Incontinence", "Fever Conversion", "Fever Convulsion", "Fever Without Focus ", "Food Poisoning", "Foreign Body", "Foreign Body Ingestion", "Fracture (tibia/fibula/humerus/radius)", "Fungal Infection", "Fussy Eater", "Gases", "Gerd", "Ghd", "Giardiasis ", "Gingivitis", "Gut Infection ", "Haematuria", "Hand Foot Mouth", "Head Injury", "Hema", "Hematuria", "Hernia", "Herpes ", "Herpes Simplex", "Herpingina", "Hfm", "Hin1", "Hunger Diarrhoea", "Hydrocoele", "Hyper Pigmentation", "Hypo  Epispadias", "Hypo-pigmentation", "Hypothyroid", "Hypothyroidism(aitd)", "Impetigo", "Inadequate Feeds ", "Indigestion", "Ineffective Diarrhoea", "Inffective Diarrhoea", "Inguinal Hernia", "Insect Bite", "Insect Bite Allergy", "Intercurrent Infection", "Jaundice", "Lactose Intolerance", "Laryngomalacia", "Lrti", "Lymphadenopathy", "Maculopapular Rash", "Malabsorption", "Malaria", "Measles ", "Meningocoel", "Mennorrhagea", "Mentally And Physically Challenged", "Mentally Challenged", "Mesenteric Adenitis", "Metabolic Syndrome", "Micro Cefali ", "Migraine", "Milia", "Motor Delay", "Mumps", "Nephrotic Syndrome", "Nocturnal Enuresis", "Nocturnal Enuress", "Nodular Urticaria", "Normal Child", "Normal New Born", "Nutritional Obesity", "Otalgia", "Over Feeding", "Overgrown Nail", "Paraphimosis", "Paratyphoid", "Paronychia", "Perianal Excoriation", "Pes Cavus", "Phimosis", "Physically Challenged", "Pica", "Pika", "Piles", "Pityriasis", "Pneumonia", "Poly Urea ", "Preterm Baby", "Prickly Heat", "Puberty", "Pulled Elbow ", "Pulmonary Kochs", "Puo", "Pyelonephritis", "Pyoderma", "Rad", "Recurrent Diarrhoea", "Refractive Error (re)", "Renal Calculai", "Rickets", "Scabies", "Scarlet Fever ", "Scoliosis", "Seborhic Dermatitis", "Severe Erosive Pangastritis", "Sga Sequel", "Short Febrile Illness", "Short Stature (const)", "Simple Seizure", "Sinusitis", "Small For Date ", "Smegma", "Spastic Dystonic ", "Spring Catarrh", "Staph", "Staph Skin Infection", "Stomatitis", "Stye", "Stye On Eye", "Swine Flu", "Syncope", "Synechia", "Teething", "Term-iugr", "Thorn Pricks ", "Thrombocytopenia", "Thrombocytosis", "Tinea", "Tinea Rosea", "Trauma", "Travel Diarrhea", "Typhoid", "Umbilical Hernia", "Undescended", "Urticaria", "Urticiria", "Uti", "Uvulitis", "Vasovagal Feet", "Viral Diarrhoea", "Viral Exanthem", "Viral Hepatitis", "Viral Syndrome", "Viral Warts", "Vitamin Def Of D", "Walri", "Weaning  Diarrhoea", "Well", "Well Child For Vaccination", "Winter Dermatitis", "Worm Infestation", "Xeroderma"];
// const all_medicine_instructions = ["If temp > 100 f", "If temp > 102 f", "At 6 hrs", "1 / day for 5 days", "Then 1 / day for 5 weeks", "Then 1 / month for 5 months", "If pain", "All medication can be given empty stomach", "Nausea/vomiting- give 20 min before feed & repeat after 15 days", "Can repeat every 4 hrs - if fever > 100", "Can mix all supplements excepts iron medicines", "Don't mix with any other medicines", "At night", "Cut open and mix with honey and give", "For cold (blocked nose)", "To be apply locally", "Insert locally", "After loose motion", "With mask and spacer", "Please give 20 min before of feed or medicines", "With curd / milk / food/ water / juice", "With food", "Mouth wash after taking medicines"];

// const all_general_instructions = ["Burp 3 times after each feeding", "Can mix all supplements except iron supplement", "Doodh halad", "Eye massage 4 times a day each cycle of 10 times", "Gargle with warm water 3-4 times / day", "Hand wash", "Hot fomentation", "No bath", "Monitor urine output", "Outdoor activity 2 hrs daily", "Plenty of water", "Encourage self feeding", "Sponge the body with water if fever is 101 degree until it comes down to 99 degree", "Steam inhalation at night", "Temp record every 3 to 4 hourly", "Use mask & spacer", "Watch for new symptoms"];
// const all_dietary_advice = ["Balanced diet", "Diet during constipation - avoid eating bread/bakery/biscuit/apple/pomegranate/packed food", "Diet during constipation - leafy vegetables/honey - hot water (3 tea spoon honey - 1 tea spoon warm water)/oats", "Diet during loose motions - ORS/rice broth/Sago/aararoot/bananas/apple/toast/avoid milk", "Exclusive breast feeding for first 6 months", "Full adult diet - 8 months onwards", "Give 100/150 ml Water/soup/sherbet/fruit juice every two hours", "Groviva protein powder - 2 scoop in 100 ml - milk / water", "Protien rich diet - eggs/chicken/fish/beans/black nuts and seeds such as peanuts and almonds", "Vegeterian protein sources", "Nourishing oats", "Self feeding and soft brushing and gum massage", "Soak black raisins over night and give water next morning", "Weaning to be started - Dal/Rice"];

// const all_investigations = ['Urine Routine And Microscopy', 'Urine Culture And Sensitivity', 'Stool Routine And Microscopy', 'Hb Gram', 'Crp', 'Calcium', 'Alkaline Phospotase', 'Vitamin D Total', 'Hba1c', 'Esr', 'Adenoid X-ray', 'Chest X-ray', 'Serum Calcium', 'Serum Ferritin', 'Tsh', 'Usg', '2-decho', 'Usg Abd', 'Usg Abdomen For Renal', 'Parameters', 'Usg Brain', 'Ct Scan- Brain', 'Mri – Spine', 'Haemogrom', 'Dengue Ns', 'Dengue Antibodies', 'Pbs For Mp', 'Optimal For Malaria', 'Thyroid Functions', 'Stool Routine And Sensitivity', 'X Ray Adenoids Lat View', 'X Ray Pns', 'X Ray Chest', 'X Ray For #', 'Stool Culture And Sensitivity', 'Varicella Titles', 'Stool Culture And Sensitivity', 'Tuberculin', 'B 12', 'Ilipd Profile', 'Sgpt', 'Rft', 'T T Test', 'Reti Count', 'Hb Electro Phoresis', 'Lft', 'Bsl', 'Dmsa', 'Sgot', 'Usg Doppler', 'Take Extra Blood Sample', 'Take Blood Sample In Plain Bulb', 'Aso', 'Suger', 'Eeg', 'Widal', 'Holter', 'Tilt Table Test', 'Take Extra Blood Sample In Plain Bulb', 'Dtp', 'Dmsa', 'Viral Titres', 'Sick Ling', 'Dengue Igg And Igm', 'Monitor Urine Out Put And Color', 'Cpk', 'Us Through Af', 'Ct Scan', 'Cd 3', 'Cd 3', 'Ear Swab Culture', 'Collet In C/s Bottle', 'Blood Culture', 'Mcu', 'Pet Scan', 'Folvite', 'Complement', 'X Ray Spine', 'Ecg', 'Ggt', 'Hplc', 'Blood Group'];


const complaint_card = [{ name: "Chief Complaints", selected: true, value: "" }, { name: "Working Diagnosis", selected: false, value: "" }];
const general_card = [{ name: "Gen. Instructions", selected: true, value: "" }, { name: "Dietary Advice", selected: false, value: "" }];
const investigation_card = [{ name: "Investigations", selected: true, value: "" }, { name: "Referral", selected: false, value: "" }];
// const nextfollowup_card = [{ name: "Next Followup", selected: true, value: "" }, { name: "Prescription Expiry", selected: false, value: "" }]
const nextfollowup_card = [{ name: "Next Followup", selected: true, value: "" }]

let drugType = [{ name: "Tablet", selected: false, value: "" }, { name: "Syrup", selected: false, value: "" }, { name: "Drop", selected: false, value: "" }, { name: "Capsule", selected: false, value: "" }, { name: "More", selected: false, value: "" }]
let dosageType = [{ name: "Morning", selected: false, value: "" }, { name: "Afternoon", selected: false, value: "" }, { name: "Evening", selected: false, value: "" }, { name: "Night", selected: false, value: "" }, { name: "Once a Week", selected: false, value: "" }, { name: "Once a Month", selected: false, value: "" }, { name: "Anytime", selected: false, value: "" },{ name: "When/If Required", selected: false, value: "" }]
let dosageUnit = [{ name: "0.5", selected: false, value: "" }, { name: "1", selected: false, value: "" }, { name: "1.5", selected: false, value: "" }, { name: "2", selected: false, value: "" }, { name: "2.5", selected: false, value: "" }, { name: "3", selected: false, value: "" }, { name: "3.5", selected: false, value: "" }, { name: "4", selected: false, value: "" }];
let whenToTake = [{ name: "Before Food", selected: false, value: "" }, { name: "After Food", selected: false, value: "" }, { name: "With Food", selected: false, value: "" }, { name: "With Milk", selected: false, value: "" }, { name: "With Fruit Juice", selected: false, value: "" }, { name: "At Bed Time", selected: false, value: "" }, { name: "Early Morning", selected: false, value: "" }, { name: "Empty Stomach", selected: false, value: "" }]
let selectFields = [{ name: "Vitals", selected: true, value: "showVitals" }, { name: "Complaints", selected: true, value: "showComplaints" }, { name: "Diagnosis", selected: true, value: "showDiagnosis" }, { name: "Prescription", selected: true, value: "showPrescription" }, { name: "General Intructions", selected: true, value: "showGeneralIntructions" }, { name: "Dietary Advice", selected: true, value: "showDiet" }, { name: "Next Followup", selected: true, value: "showNextFollowup" }];
let followupArray:any[] = [{ name: "Call", selected: false }, { name: "Report", selected: false }, { name: "Visit-or-Appointment", selected: false }]


@Component({
  selector: "app-prescriptions",
  templateUrl: "./prescriptions.component.html",
  styleUrls: ["./prescriptions.component.scss"],
  animations: [openClose],
  providers: [MessageService],
})

export class prescriptionsComponent implements OnInit, OnDestroy {
  userId:any = null;
  patientId:any = null;
  appointmentId:any = null;
  patient: any = { User: {} };
  age: any = {};
  ageObj: any = {};
  serachMedDuplicate:any=[]
  showAge=false;
  drug:any = null;
  visitId:any = null;
  currentFavMedObj: any = {};
  visits: any = [];
  vitalsArray: any = [];
  closeResult: any;
  medicine: any = { Drug: {} };
  medicineArry:any={};
  showRequisitionLoading = true;
  fullName: any = '';
  dob: any = '';
  gender: any = '';

  date = new Date();
  modalRef: any = null;
  languages:any[] = [];
  templateArr:any[] = [];
  selectedInstructions:any[] = [];
  showLoading = false;
  appointmentData: any;
  patientData: any;


  chief_complaints: string = '';
  working_diagnosis: string = '';
  medicine_instructions: string = '';
  observations: string = '';
  notes: string = '';
  printingFields: string = '';

  general_instructions: string = '';
  dietary_advices: string = '';

  investigations: string = '';
  referral: string = '';

  nextFollowUp: string = '';
  prescriptionExpirationDate: string = '';

  selectedFollowupStr: string = '';
  selectedFieldType: string = '';
  selectedDrugType: string = '';
  selectedDosageUnit: any = '';
  selectedDosageType: any = '';
  selectedWhenToTake: string = '';

  selectedTabComplaints: string = 'Chief Complaints';
  selectedTabGeneral: string = 'Gen. Instructions';
  selectedTabInvestigation: string = 'Investigations';
  selectedTabFollowup: string = 'Next Followup';

  complaintsCardArray: any = [];
  generalCardArray: any = [];
  investigationCardArray: any = [];
  nextFollowUpCardArray: any = [];

  drugTypeArray: any[] = [];
  dosageTypeArray: any[] = [];
  dosageUnitArray: any[] = [];
  whenToTakeArray: any[] = [];
  selectFieldsArray: any[] = [];

  doseUnitType: string = '';

  followupArray: any = followupArray;

  allComplaintsArray: any[] = [];
  allComplaintsArrayOg: any[] = [];

  allDiagnosisArray: any[] = [];
  allDiagnosisArrayOg: any []= [];

  allMedicineInstructionsArray: any[] = [];
  allMedicineInstructionsArrayOg: any = [];

  allGeneralInstructionsArray: any[] = [];
  allGeneralInstructionsArrayOg: any = [];

  allDietaryAdvicesArray: any[] = [];
  allDietaryAdvicesArrayOg: any = [];

  allInvestigationsArray: any = [];
  allInvestigationsArrayOg: any = [];

  drugTypes: any[] = [];
  drugTypesOg: any = [];
  selectFieldss: any = [];
  mytextarea: string = '';
  searchedMeds: any = [];
  selectedMedicineObject: any = {};
  days: string = '';
  yourtext: string = 'Hello';

  prescriptionPreviewArray: any = [];
  dosePreviewArray: any = [];
  prescriptionArrElement: any = {};

  drugTypeAddNewDrugs: string = '';
  drugCompanyAddNewDrugs: string = '';
  genericDrugNameAddNewDrugs: string = '';
  drugNameAddNewDrugs: string = '';

  selectedIncrementNumber: number = 0;
  previousMedsArr: any = [];
  selectedPreviousMed:any[] = [];
  selectedFavMed:any[] = [];
  selectedPreviousMedDate = 'Choose';
  selectedPreviousFavMed = "Choose";
  selectedTimeType = 'Day(s)';

  timeTypeArr: any = ['Day(s)', 'Week(s)', 'Month(s)'];
  languageArray: any = [{ name: 'English', language: 'en' }, { name: 'Marathi', language: 'mr' }, { name: 'Hindi', language: 'hi' }, { name: 'Kannada', language: 'kn' }];
  selectedLanguage: any = { name: "English", language: 'en' };
  templateName: any = "Speciality";
  selectedTemplate: any = [];
  medicine_list: any[] = [];

  unselectedDrugName = false;
  unselectedTemplateName = false;
  unselectedDrugType = false;
  unselectedDosageUnit = false;
  unselectedDosageType = false;
  unselectedDays = false;
  deletedMedicineArr: any = [];
  favArry: any = [];
  isEditPrescription: boolean = false;



  constructor(
    private modalService: NgbModal,
    private util: UtilService,
    private authService: AuthService,
    private userService: UserService,
    private confirmationService: ConfirmationService,
    private storageService: StorageService,
    private route: ActivatedRoute,
    private router: Router,
    private patientService: PatientService,
    private toastr: ToastrService,
    private globalService: GlobalService,
    public datepipe: DatePipe,
    private doctorService: DoctorService,
    private activatedRoute: ActivatedRoute,
    private messageService: MessageService,

  ) {
    this.userId = this.authService.getUser();

    // this.todaysDate = this.datepipe.transform(new Date(), "dd/MM/yyyy");

    // var patient = localStorage.getItem('patientData');
    // this.patientData = JSON.parse(patient);
    localStorage.removeItem("covidques");

    this.medicine.dosage = 'Tablet';


    this.complaintsCardArray = complaint_card;
    this.generalCardArray = general_card;
    this.investigationCardArray = investigation_card;
    this.nextFollowUpCardArray = nextfollowup_card;
    this.drugTypeArray = drugType;

    this.dosageTypeArray = dosageType;
    this.dosageUnitArray = dosageUnit;
    this.whenToTakeArray = whenToTake;
    this.selectFieldsArray = selectFields;

  }

  getAllRequiredConstants = () => {
    this.patientService.getAllRequiredConstants('').subscribe((response:any) => {
      if (response) {

        console.log("Response Constants", response);

        this.allComplaintsArray = response.data.complaints.map((ins:any) => { return { name: ins.name, selected: false } });
        this.allComplaintsArrayOg = response.data.complaints.map((ins:any) => { return { name: ins.name, selected: false } });

        this.allDiagnosisArray = response.data.diagnosis.map((ins:any) => { return { name: ins.name, selected: false } });
        this.allDiagnosisArrayOg = response.data.diagnosis.map((ins:any) => { return { name: ins.name, selected: false } });

        this.allMedicineInstructionsArray = response.data.medicineInstructions.map((ins:any) => { return { name: ins.name, selected: false } });
        this.allMedicineInstructionsArrayOg = response.data.medicineInstructions.map((ins:any) => { return { name: ins.name, selected: false } });

        this.allGeneralInstructionsArray = response.data.generalInstructions.map((ins:any) => { return { name: ins.name, selected: false } });
        this.allGeneralInstructionsArrayOg = response.data.generalInstructions.map((ins:any) => { return { name: ins.name, selected: false } });

        this.allDietaryAdvicesArray = response.data.dietaryAdvice.map((ins:any) => { return { name: ins.name, selected: false } });
        this.allDietaryAdvicesArrayOg = response.data.dietaryAdvice.map((ins:any) => { return { name: ins.name, selected: false } });

        this.allInvestigationsArray = response.data.investigations.map((ins:any) => { return { name: ins.name, selected: false } });
        this.allInvestigationsArrayOg = response.data.investigations.map((ins:any) => { return { name: ins.name, selected: false } });

        this.drugTypes = response.data.drugTypes.map((ins:any) => { return { name: ins.name, selected: false } });
        this.drugTypesOg = response.data.drugTypes.map((ins:any) => { return { name: ins.name, selected: false } });


      } else {
        alert('Something went wrong')
      }
    });
  }

  initialization = () => {
    this.selectedTabComplaints = "Chief Complaints";
    this.selectedTabGeneral = "Gen. Instructions"
    this.complaintsCardArray[0].selected = true;
    this.complaintsCardArray[1].selected = false;
    this.generalCardArray[0].selected = true;
    this.generalCardArray[1].selected = false;

  }

  ngOnInit() {
    // this.selectedPreviousFavMed = 'Choo';
    this.templateName = 'default';

    this.route.queryParams
    .subscribe((params:any) => {
      console.log("log8", params); // { orderby: "price" }
     
    
      
    }
    )
    this.route.queryParams
      .subscribe((params:any) => {
        console.log("log2", params); // { orderby: "price" }
        // if(params.patientidfornewappt){
        //   this.patientId = params;
        // }
        this.patientId = params;
        console.log("msl", this.patientId); // price
        
      }
      )
      this.activatedRoute.queryParams
      .pipe(
        filter((params: any) => params.patientId) // Use filter inside pipe
      )
      .subscribe((params: any) => {
        console.log("lsm", params); // { patientId: value }
        this.patientId = params.patientId;
      });
      

    // this.patientId = history.state.patientId;
    this.getPatientInfo();
    this.getAllRequiredConstants();
    this.getAllDoctorPrescriptions();
    this.getFavApptsOfDoctor()
    this.getPrescription();
    //this.getAllDoctorFavPrescription()
    this.initialization();
    this.getDoctorDetails()


    // this.today = this.util.reverseDate(new Date())
    $("textarea").keyup(function (event:any) {
      let re = /(^|[.!?]\s+)([a-z])/g;
      var textBox: HTMLInputElement = <HTMLInputElement>event.target;
      //textBox.value = textBox.value.charAt(0).toUpperCase() + textBox.value.slice(1).toLowerCase();
      textBox.value = textBox.value.replace(
        re,
        (m, $1, $2) => $1 + $2.toUpperCase()
      );
    });
  }

  onDropdownSelect = (item:any) => {
    this.selectedPreviousMedDate = item.value;

    this.selectedPreviousMed = item.medicine;
  }
  onDropdownSelectFavMed = (item:any) => {

    this.selectedPreviousFavMed = item.value;
    this.selectedFavMed = item.medicine;
    this.currentFavMedObj = item;
    //  this.favArry=item.medicine
    //this.favArry = item.medicine;
  }

  onDropdownSelectTime = (item:any) => {

    this.selectedTimeType = item;
  }

  onDropdownSelectLanguage = (item:any) => {
    this.selectedLanguage = item
  }

  onDropdownSelectTemplate = (item:any) => {
    this.templateName = item
  }
  ngOnDestroy() {
    if (this.modalRef) {
      this.modalRef.close();
    }
  }

  goBack = () => {
    this.router.navigate([`/doctor/patients/profileSummary/view`], {});
  }

  clearSelection = (flag:any) => {

    //type 0 = add dose
    //type 1 = add medicine

    this.selectedDosageUnit = '';
    this.dosageUnitArray.map((ins:any) => ins.selected = false);

    this.selectedDosageType = '';
    this.dosageTypeArray.map((ins:any) => ins.selected = false);
    




    if (flag == 1) {
      this.selectedDrugType = '';
      this.drugTypeArray.map((ins:any) => ins.selected = false);
      this.yourtext = "";
      this.medicine_instructions = "";

      this.selectedWhenToTake = '';
      this.whenToTakeArray.map((ins:any) => ins.selected = false);
    }
  }

  addToPrescription = () => {
  //  this.addDose(0);
  
  

   // this.dosePreviewArray[0].whenToTake=this.selectedWhenToTake;
  
    this.dosePreviewArray.map((ins:any) => {
      console.log("dosahe", this.dosePreviewArray)
    })

    if (this.dosePreviewArray.length) {
      console.log("dosahe", this.dosePreviewArray)
     // this.dosePreviewArray[0].whenToTake=this.selectedWhenToTake;
  
      this.dosePreviewArray[0].instructions = this.medicine_instructions;
      this.medicine_list[this.medicine_list.length - 1].instructions = this.medicine_instructions;
      this.medicine_list[this.medicine_list.length - 1].duration2= this.selectedWhenToTake;
    }
    this.prescriptionPreviewArray = [...this.prescriptionPreviewArray, ...this.dosePreviewArray];
    this.dosePreviewArray = [];
    this.clearSelection(1);
  }


  clearDosePreview = () => {
    this.dosePreviewArray = [];
  }


  addDose(type:any) {
    this.validate();
    //type 0 = add dose
    //type 1 = add medicine

    var timeArr: any = [];
    this.dosageTypeArray.map((ins:any) => {
      if (ins.selected) {
        timeArr.push(ins.name);
      }

    });

    let element = {

      drugType: this.selectedDrugType,

      dose: this.selectedDosageUnit,
      time: timeArr.join(', '),
      whenToTake: this.selectedWhenToTake,
      days: this.days,
      medicineName: this.selectedMedicineObject.product_name
    }

    if (element.drugType && element.dose && element.time && element.days && element.medicineName) {
      let newDose: any = true;
      let index = 0;
      this.dosePreviewArray.map((ins:any, ind:any) => {
        if (this.selectedMedicineObject.product_name == ins.medicineName) {
          newDose = false;
          index = ind;
        }
      });

      //  if(element.drugType='Syrup'){
      //  this.selectedDosageUnit = this.selectedDosageUnit.replace('½', "0.5")
      //  this.selectedDosageUnit = this.selectedDosageUnit.replace('½', ".5")


      if (newDose) {
        // if(this.doseUnitType){
        //   this.selectedDosageUnit = this.selectedDosageUnit.replace('½', "0.5")
        //   this.selectedDosageUnit = this.selectedDosageUnit.replace('½', ".5")
        // }
        if (this.doseUnitType == "ml") {
          this.selectedDosageUnit = this.selectedDosageUnit.replace('¼', "0.25");
          this.selectedDosageUnit = this.selectedDosageUnit.replace('¼', ".25");
          this.selectedDosageUnit = this.selectedDosageUnit.replace('¾', "0.75");
          this.selectedDosageUnit = this.selectedDosageUnit.replace('¾', ".75");
          this.selectedDosageUnit = this.selectedDosageUnit.replace('½', "0.5");
          this.selectedDosageUnit = this.selectedDosageUnit.replace('½', ".5");
        }
        else {
          this.selectedDosageUnit = this.selectedDosageUnit.replace("0.25",'¼');
          this.selectedDosageUnit = this.selectedDosageUnit.replace(".25",'¼');
          this.selectedDosageUnit = this.selectedDosageUnit.replace( "0.75",'¾');
          this.selectedDosageUnit = this.selectedDosageUnit.replace(".75",'¾');
          this.selectedDosageUnit = this.selectedDosageUnit.replace('0.5', "½")
          this.selectedDosageUnit = this.selectedDosageUnit.replace('.5', "½")
        }










        let obj: any = {}
        // obj.id = this.selectedMedicineObject.id;
        obj.Drug = this.selectedMedicineObject;
        obj.dosagePreviewMed = `${this.selectedDosageUnit}  ${this.doseUnitType} - ${timeArr.join(', ')} - ${this.selectedWhenToTake} -  ${this.selectedTimeType}${this.days}`;
        // obj.dosage2 = `${this.selectedDosageUnit} - ${this.doseUnitType} - ${timeArr.join(', ')} -- ${this.days} ${this.selectedTimeType}`;
        obj.duration2 = this.selectedWhenToTake
        obj.duration3 = this.days;
        obj.duration4 = this.selectedTimeType;
        obj.finalPreview = `${this.selectedDosageUnit}  ${this.doseUnitType} - ${timeArr.join(', ')} - ${this.selectedWhenToTake} -  ${this.selectedTimeType}${this.days}`;
        obj.frequency2 = timeArr.join(', ');
        obj.instructions = this.medicine_instructions;
        obj.dosageArr = []
        timeArr.map((ins:any) => {

          //  obj. this.selectedDosageUnit = this.selectedDosageUnit.replace('½', "0.5");
          // obj. this.selectedDosageUnit = this.selectedDosageUnit.replace('½', ".5");
          
          // obj.dosageArr.push(`${this.selectedDosageUnit} - ${this.doseUnitType} - ${ins} - ${this.selectedWhenToTake} - ${this.days} ${this.selectedTimeType}`)
          obj.dosageArr.push(`${this.selectedDosageUnit}  ${this.doseUnitType} - ${ins} `)
        });
        obj.dosageArr.push(`${this.days} ${this.selectedTimeType}`)

        obj.dosage2 = obj.dosageArr.join(', ');

        this.medicine_list.push(obj);

        let element:any = [{
          // id: this.selectedMedicineObject.id,
          drugType: this.selectedDrugType,
          // dose: this.selectedDosageUnit,
          dose: this.selectedDosageUnit,
          time: timeArr.join(', '),
          whenToTake: this.selectedWhenToTake,
          days: this.days,
          medicineName: this.selectedMedicineObject.product_name,
          // dosage2: `${this.selectedDosageUnit} - ${this.doseUnitType} - ${timeArr.join(', ')} - ${this.selectedWhenToTake} - ${this.days} ${this.selectedTimeType}`,
          dosage2: "",
          instructions: this.medicine_instructions,
          dosageArr: []
          // {{element.dose}} - {{element.drugType}} - {{element.time}} -{{element.whenToTake}} - {{element.days}} Day(s) 
        }];

        timeArr.map((ins:any) => {
          element[0].dosageArr.push(`${this.selectedDosageUnit}  ${this.doseUnitType} - ${ins} `)
        });
        element[0].dosageArr.push(`${this.days} ${this.selectedTimeType}`);
        element[0].dosage2 = element[0].dosageArr.join(', ')


        if (element[0].drugType && element[0].dose && element[0].time && element[0].days && element[0].medicineName) {
          this.dosePreviewArray.push(element[0]);
          if (type == 1) {
            this.clearSelection(1)
          } else {
            this.clearSelection(0);
          }

        }


      } else {
        let timeArr2:any[] = [];
        this.dosageTypeArray.map((ins:any) => {
          if (ins.selected) {
            timeArr2.push(ins.name);
          }
        });

        if (this.doseUnitType == "ml") {
          this.selectedDosageUnit = this.selectedDosageUnit.replace('¼', "0.25");
          this.selectedDosageUnit = this.selectedDosageUnit.replace('¼', ".25");
          this.selectedDosageUnit = this.selectedDosageUnit.replace('¾', "0.75");
          this.selectedDosageUnit = this.selectedDosageUnit.replace('¾', ".75");
          this.selectedDosageUnit = this.selectedDosageUnit.replace('½', "0.5");
          this.selectedDosageUnit = this.selectedDosageUnit.replace('½', ".5");
        }
        else {
          this.selectedDosageUnit = this.selectedDosageUnit.replace( "0.25",'¼');
          this.selectedDosageUnit = this.selectedDosageUnit.replace(".25",'¼');

          this.selectedDosageUnit = this.selectedDosageUnit.replace( "0.75",'¾');
          this.selectedDosageUnit = this.selectedDosageUnit.replace(".75",'¾');
          
          this.selectedDosageUnit = this.selectedDosageUnit.replace('0.5', "½");
          this.selectedDosageUnit = this.selectedDosageUnit.replace('.5', "½");
        }



        this.medicine_list.map((ins:any, i:any) => {
          if (ins.Drug.product_name == this.selectedMedicineObject.product_name) {
            timeArr2.map(time => {
              this.dosePreviewArray[0].dosageArr.forEach((x:any, i:any) => {
                if (x.includes(time)) {
                  console.log("removed extra element");
                  this.dosePreviewArray[0].dosageArr.splice(i, 1)
                }
              })
             
              this.dosePreviewArray[index].dosageArr.push(`${this.selectedDosageUnit} ${this.doseUnitType} ${time} --  ${this.selectedTimeType}${this.days}`)
              // this.dosePreviewArray[index].dosageArr.push(`${this.selectedDosageUnit} - ${this.doseUnitType} - ${time} - ${this.selectedWhenToTake} - ${this.days} ${this.selectedTimeType}`)
            });

            //defer
            // ins.dosage2 = ins.dosage2 + ', ' + `${this.selectedDosageUnit} - ${this.doseUnitType} - ${timeArr2.join(', ')} - ${this.days} ${this.selectedTimeType}`;
            ins.dosage2 = this.dosePreviewArray[index].dosageArr.join(', ')

            ins.dosagePreviewMed = ins.dosagePreviewMed + ', ' + `${this.selectedDosageUnit} ${this.doseUnitType} ${timeArr2.join(', ')} - ${this.selectedWhenToTake} -  ${this.selectedTimeType}-${this.days}`;
            ins.finalPreview = ins.finalPreview + `, ${this.selectedDosageUnit}  ${this.doseUnitType}  ${timeArr2.join(', ')} - ${this.selectedWhenToTake} -  ${this.selectedTimeType}-${this.days}`

            //logic
            // let arr = ins.dosage2.split(',');
            let arr = this.dosePreviewArray[index].dosageArr
            let newArr:any[] = [];
            arr.map((ins:any) => {
              if (ins.includes('Morning')) {
                newArr.push({ index: 0, name: ins })
              }
              if (ins.includes('Afternoon')) {
                newArr.push({ index: 1, name: ins })
              }
              if (ins.includes('Evening')) {
                newArr.push({ index: 2, name: ins })
              }
              if (ins.includes('Night')) {
                newArr.push({ index: 3, name: ins })
              }
              if (ins.includes('Once a Week')) {
                newArr.push({ index: 4, name: ins })
              }
              if (ins.includes('Once a Month')) {
                newArr.push({ index: 5, name: ins })
              }
              if (ins.includes('Anytime')) {
                newArr.push({ index: 6, name: ins })
              }
            });

            newArr = _.sortBy(newArr, function (obj) {
              return obj.index;
            });

            let finalArray:any[] = [];
            newArr.map(ins => {
              finalArray.push(ins.name);
            });

            this.dosePreviewArray[index].dosageArr = finalArray;
            // ins.dosage2 = finalArray.join();

          }
        });
        //defer
        // this.dosePreviewArray[index].dosage2 = this.dosePreviewArray[index].dosage2 + ', ' + `${this.selectedDosageUnit} - ${this.doseUnitType} - ${timeArr2.join(', ')} - ${this.selectedWhenToTake} - ${this.days} ${this.selectedTimeType}`
        this.dosePreviewArray[index].dosage2 = this.dosePreviewArray[index].dosageArr.join(', ')
      }

    }




    if (type == 1) {
      this.clearSelection(1)
    } else {
      this.clearSelection(0);
    }
  }

  //Old method -- deprecated
  // addDose = (type) => {
  //   this.validate();

  //   //type 0 = add dose
  //   //type 1 = add medicine

  //   var timeArr: any = [];
  //   this.dosageTypeArray.map(ins => {
  //     if (ins.selected) {
  //       timeArr.push(ins.name);
  //     }
  //   });

  //   let element = {
  //     drugType: this.selectedDrugType,
  //     dose: this.selectedDosageUnit,
  //     time: timeArr.join(', '),
  //     whenToTake: this.selectedWhenToTake,
  //     days: this.days,
  //     medicineName: this.selectedMedicineObject.product_name
  //   }

  //   if (element.drugType && element.dose && element.time && element.days && element.medicineName) {
  //     let newDose = true;
  //     let index = 0;
  //     this.dosePreviewArray.map((ins, ind) => {
  //       if (this.selectedMedicineObject.product_name == ins.medicineName) {
  //         newDose = false;
  //         index = ind;
  //       }
  //     })

  //     if (newDose) {

  //       this.selectedDosageUnit = this.selectedDosageUnit.replace('0.5', "½")
  //       this.selectedDosageUnit = this.selectedDosageUnit.replace('.5', "½")

  //       let obj: any = {}
  //       // obj.id = this.selectedMedicineObject.id;
  //       obj.Drug = this.selectedMedicineObject;
  //       obj.dosagePreviewMed = `${this.selectedDosageUnit} - ${this.doseUnitType} - ${timeArr.join(', ')} - ${this.selectedWhenToTake} - ${this.days} ${this.selectedTimeType}`;
  //       obj.dosage2 = `${this.selectedDosageUnit} - ${this.doseUnitType} - ${timeArr.join(', ')} -- ${this.days} ${this.selectedTimeType}`;
  //       obj.duration2 = this.selectedWhenToTake
  //       obj.duration3 = this.days;
  //       obj.duration4 = this.selectedTimeType;
  //       obj.finalPreview = `${this.selectedDosageUnit} - ${this.doseUnitType} - ${timeArr.join(', ')} - ${this.selectedWhenToTake} - ${this.days} ${this.selectedTimeType}`;
  //       obj.frequency2 = timeArr.join(', ');
  //       obj.instructions = this.medicine_instructions;

  //       this.medicine_list.push(obj);



  //       let element = [{
  //         // id: this.selectedMedicineObject.id,
  //         drugType: this.selectedDrugType,
  //         // dose: this.selectedDosageUnit,
  //         dose: this.selectedDosageUnit,
  //         time: timeArr.join(', '),
  //         whenToTake: this.selectedWhenToTake,
  //         days: this.days,
  //         medicineName: this.selectedMedicineObject.product_name,
  //         dosage2: `${this.selectedDosageUnit} - ${this.doseUnitType} - ${timeArr.join(', ')} - ${this.selectedWhenToTake} - ${this.days} ${this.selectedTimeType}`,
  //         instructions: this.medicine_instructions
  //         // {{element.dose}} - {{element.drugType}} - {{element.time}} -{{element.whenToTake}} - {{element.days}} Day(s) 
  //       }]

  //       if (element[0].drugType && element[0].dose && element[0].time && element[0].days && element[0].medicineName) {
  //         this.dosePreviewArray.push(element[0]);
  //         if (type == 1) {
  //           this.clearSelection(1)
  //         } else {
  //           this.clearSelection(0);
  //         }

  //       }
  //     } else {
  //       // Same medicine - other dose
  //       let timeArr2 = [];
  //       this.dosageTypeArray.map(ins => {
  //         if (ins.selected) {
  //           timeArr2.push(ins.name);
  //         }
  //       });

  //       this.selectedDosageUnit = this.selectedDosageUnit.replace('0.5', "½")
  //       this.selectedDosageUnit = this.selectedDosageUnit.replace('.5', "½")

  //       this.medicine_list.map((ins, i) => {
  //         if (ins.Drug.product_name == this.selectedMedicineObject.product_name) {

  //           // if (timeArr2.length > 1) {
  //           //   alert('Do se zyada hai')
  //           // } else {

  //           //   if (ins.dosage2.includes('Morning')) {
  //           //     let ind = timeArr2.indexOf("Morning");
  //           //     timeArr2.splice(ind, 1)
  //           //   }
  //           //   if (ins.dosage2.includes('Afternoon')) {
  //           //     let ind = timeArr2.indexOf("Afternoon");
  //           //     timeArr2.splice(ind, 1)
  //           //   }
  //           //   if (ins.dosage2.includes('Evening')) {
  //           //     let ind = timeArr2.indexOf("Evening");
  //           //     timeArr2.splice(ind, 1)
  //           //   }
  //           // }


  //           ins.dosage2 = ins.dosage2 + ', ' + `${this.selectedDosageUnit} - ${this.doseUnitType} - ${timeArr2.join(', ')} - ${this.days} ${this.selectedTimeType}`;
  //           ins.dosagePreviewMed = ins.dosagePreviewMed + ', ' + `${this.selectedDosageUnit} - ${this.doseUnitType} - ${timeArr2.join(', ')} - ${this.selectedWhenToTake} - ${this.days} ${this.selectedTimeType}`;;
  //           ins.finalPreview = ins.finalPreview + `, ${this.selectedDosageUnit} - ${this.doseUnitType} - ${timeArr2.join(', ')} - ${this.selectedWhenToTake} - ${this.days} ${this.selectedTimeType}`

  //           //logic
  //           let arr = ins.dosage2.split(',');
  //           let newArr = [];
  //           arr.map(ins => {
  //             if (ins.includes('Morning')) {
  //               newArr.push({ index: 0, name: ins })
  //             }
  //             if (ins.includes('Afternoon')) {
  //               newArr.push({ index: 1, name: ins })
  //             }
  //             if (ins.includes('Evening')) {
  //               newArr.push({ index: 2, name: ins })
  //             }
  //             if (ins.includes('Night')) {
  //               newArr.push({ index: 3, name: ins })
  //             }
  //             if (ins.includes('Once-a-week')) {
  //               newArr.push({ index: 4, name: ins })
  //             }
  //             if (ins.includes('Once-a-month')) {
  //               newArr.push({ index: 5, name: ins })
  //             }
  //             if (ins.includes('Anytime')) {
  //               newArr.push({ index: 6, name: ins })
  //             }
  //           });

  //           newArr = _.sortBy(newArr, function (obj) {
  //             return obj.index;
  //           });

  //           let finalArray = [];
  //           newArr.map(ins => {
  //             finalArray.push(ins.name);
  //           });

  //           ins.dosage2 = finalArray.join();

  //         }
  //       });


  //       this.dosePreviewArray[index].dosage2 = this.dosePreviewArray[index].dosage2 + ', ' + `${this.selectedDosageUnit} - ${this.doseUnitType} - ${timeArr2.join(', ')} - ${this.selectedWhenToTake} - ${this.days} ${this.selectedTimeType}`
  //     }


  //     //re arrange according to time of the day
  //     let arr = this.dosePreviewArray[0].dosage2.split(',');
  //     let newArr = [];
  //     arr.map(ins => {
  //       if (ins.includes('Morning')) {
  //         newArr.push({ index: 0, name: ins })
  //       }
  //       if (ins.includes('Afternoon')) {
  //         newArr.push({ index: 1, name: ins })
  //       }
  //       if (ins.includes('Evening')) {
  //         newArr.push({ index: 2, name: ins })
  //       }
  //       if (ins.includes('Night')) {
  //         newArr.push({ index: 3, name: ins })
  //       }
  //       if (ins.includes('Once-a-week')) {
  //         newArr.push({ index: 4, name: ins })
  //       }
  //       if (ins.includes('Once-a-month')) {
  //         newArr.push({ index: 5, name: ins })
  //       }
  //       if (ins.includes('Anytime')) {
  //         newArr.push({ index: 6, name: ins })
  //       }
  //     });

  //     newArr = _.sortBy(newArr, function (obj) {
  //       return obj.index;
  //     });

  //     let finalArray = [];
  //     newArr.map(ins => {
  //       finalArray.push(ins.name);
  //     });

  //     this.dosePreviewArray[0].dosage2 = finalArray.join();

  //     console.log('Hello', JSON.stringify(newArr))

  //     if (type == 1) {
  //       this.clearSelection(1)
  //     } else {
  //       this.clearSelection(0);
  //     }
  //   }
  // }

  getSearchedMeds = (searchString:any) => {
    if (searchString.length > 3) {
      var obj = { "query": searchString };
      this.patientService.getDrugs(obj).subscribe((response:any) => {
        this.searchedMeds  = response.drugs.reduce((unique:any, o:any) => {
                           if (!unique.some((obj:any) => obj.product_name.replaceAll(' ', '').toLowerCase() === o.product_name.replaceAll(' ', '').toLowerCase() && obj.product_type === o.product_type)) {
                               unique.push(o);
                           }
                           return unique;
                       }, []);

    })
  }
   }


searchDupicate(){
  //return [...new Map(arr.map(item => [item[key], item])).values()]

  var filterArray = this.searchedMeds.reduce((accumalator:any, current:any) => {
    if(!accumalator.some((item:any) => item.product_name === current.product_name && item.product_type === current.product_type)) {
      accumalator.push(current);
    }
    return accumalator;
},[]);
console.log(filterArray)
  

}

  incrementDose = () => {
    //this.selectedIncrementNumber
    this.selectedDosageUnit = (Number(this.selectedDosageUnit) + this.selectedIncrementNumber).toString();
  }

  decrementDose = () => {
    this.selectedDosageUnit = (Number(this.selectedDosageUnit) - this.selectedIncrementNumber >= 0 ? Number(this.selectedDosageUnit) - this.selectedIncrementNumber : this.selectedDosageUnit).toString();
  }

  formatter = (result: any) => result.product_name;
  formatMatches = (result: any) => result.product_name ? result.product_name : '';

  selectedItem = (item:any) => {
    
    // let array = this.drugTypeArray;
    // this.unselectedDrugType = false;
    // array.map((ins, ind) => {
    //   if (ind == index) {
    //     array[index].selected = true;
    //     this.selectedDrugType = ins.name;
    //     this.selectedDosageUnit = this.dosageUnitArray[0].name
    //   } else {
    //     ins.selected = false;
    //   }
    // });

    // this.selectDosageTypeForDrugs(index);

    console.log("SELECTED - ", JSON.stringify(item.item))
    console.log("ALL - ", JSON.stringify(this.drugTypesOg))
    this.selectedMedicineObject = item.item;

    let cond = item.item.product_type.toLowerCase();
    let cond2 = item.item.product_name.toLowerCase();

    if (cond.includes('tablet') || cond.includes('syrup') || cond.includes('drop') || cond.includes('capsule') ||
      cond2.includes('tablet') || cond2.includes('syrup') || cond2.includes('drop') || cond2.includes('capsule')
    ) {
      this.drugTypeArray.map((item:any, index:any) => {

        if (cond.includes(item.name.toLowerCase()) || cond2.includes(item.name.toLowerCase())) {
          // this.drugTypeArray[index].selected = true;
          // this.selectedDrugType = this.drugTypeArray[index].name;
        }

      });
    } else {
      this.drugTypesOg.map((item:any, index:any) => {
        if (cond.includes(item.name.toLowerCase())) {
          this.drugTypeArray.map((ins:any) => ins.selected = false);
          // item.selected = true;
          this.drugTypeArray.push(item);
          // this.selectedDrugType = item.name;
        }
      });
    }
  }


  search = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map(term => term === '' ? []
        : this.searchedMeds.filter((v:any) => v))
    )


  getPatientInfo = () => {


    // this.fullName = patientObj.User.first_name + " " + patientObj.User.last_name;
    // this.gender = patientObj.User.gender == 'male' ? 'M' : 'F';
    // this.dob = patientObj.User.dob
    // this.age = moment().diff(this.dob, 'years');

    this.patientService.getPatientInfo(this.patientId).subscribe((response:any) => {
      if (response) {
        console.log("Response Patients", response);

        this.fullName = response.firstName + " " + response.lastName;
        this.gender = response.gender.toLowerCase() == 'male' ? 'M' : 'F';
        this.dob = response.DOB
        this.ageObj = response.age;
        if(this.ageObj.years <1){
         // this.ageObj.years="Under 1 Year";
          this.showAge=true;
        }
        else{
          this.ageObj.years;
          this.showAge=false;
        }
        this.age = moment().diff(this.dob, 'years');

        this.patient = response;
        this.visits = response.visits && response.visits.length ? response.visits : [];

        this.visits.map((element:any, index:any) => {
          if (element._id === "synthetic_record") {
            this.visits.splice(index, 1);
          }
        });


        this.getPatientAgeCategory();
      } else {
        alert('Something went wrong')
      }
    });

  }

  getPatientAgeCategory = () => {
    //Pediatrics - Age till 3 Years
    // Weight Height HC CC

    //Pediatrics - Age > 3 Years and less than 18
    // Weight Height BMI BP(sys) BP(dys)

    //GP - Adult
    //Weight Height BMI BP(sys) BP(dys) Blood Sugar(Fasting) Blood Sugar(PP)

    let visits = this.visits && this.visits.length ? this.visits[this.visits.length - 1] : [];
    let vitalsArray = this.vitalsArray;

    let weight = visits.weight && visits.weight != "null" ? visits.weight : 'N/A';
    let height = visits.height && visits.height != "null" ? visits.height : 'N/A';
    let hc = visits.hc && visits.hc != "null" ? visits.hc : 'N/A';
    let cc = visits.cc && visits.cc != "null" ? visits.cc : 'N/A';
    let bmi_calc = (visits.weight / visits.height / visits.height) * 10000;
    let num = Number(bmi_calc).toFixed(2);
    let bmi = visits.weight && visits.weight && visits.height && visits.height != "null" && !isNaN(bmi_calc) ? num : 'N/A';
    if(!Number.isNaN(bmi)){
      bmi=''
    }
    else{
      bmi;
    }
    let bpSys = visits.bpSys && visits.bpSys != "null" ? visits.bpSys : 'N/A';
    let bpDia = visits.bpDia && visits.bpDia != "null" ? visits.bpDia : 'N/A';
    let Bloodsugar_F = visits.Bloodsugar_F && visits.Bloodsugar_F != "null" ? visits.Bloodsugar_F : 'N/A';
    let Bloodsugar_PP = visits.Bloodsugar_PP && visits.Bloodsugar_PP != "null" ? visits.Bloodsugar_PP : 'N/A';


    if (this.age < 4) {
      vitalsArray.push({ value: weight, name: 'Weight', unit: 'kg' });
      vitalsArray.push({ value: height, name: 'Height', unit: 'cm' })
      vitalsArray.push({ value: hc, name: 'HC', unit: 'cm' })
      vitalsArray.push({ value: cc, name: 'CC', unit: 'cm' })

    } else if (this.age < 18) {
      vitalsArray.push({ value: weight, name: 'Weight', unit: 'kg' });
      vitalsArray.push({ value: height, name: 'Height', unit: 'cm' })
      vitalsArray.push({ value: bmi, name: 'BMI', unit: '' });


      vitalsArray.push({ value: bpSys, name: 'BP(Sys)', unit: '' })
      vitalsArray.push({ value: bpDia, name: 'BP(Dia)', unit: '' })
    } else {
      vitalsArray.push({ value: weight, name: 'Weight', unit: 'kg' });
      vitalsArray.push({ value: height, name: 'Height', unit: 'cm' })
      vitalsArray.push({ value: bmi, name: 'BMI', unit: '' })
      vitalsArray.push({ value: bpSys, name: 'BP(Sys)', unit: '' })
      vitalsArray.push({ value: bpDia, name: 'Bp(Dia)', unit: '' })
      vitalsArray.push({ value: Bloodsugar_F, name: 'Blood Sugar F', unit: '' })
      vitalsArray.push({ value: Bloodsugar_PP, name: 'Blood Sugar PP', unit: '' })
    }

    console.log("AGE", this.age)
    console.log("Vitals Array", vitalsArray)
  }



  open(content:any, type:any) {

    switch (type) {
      case 'complaints_modal':
        this.allComplaintsArray = this.allComplaintsArrayOg;
        if (this.allComplaintsArray.length) {
          this.allComplaintsArray.map((ins:any, ind:any) => {
            ins.selected = false;
            if (this.chief_complaints) {
              this.chief_complaints.split(', ').map(itr => {

                if (ins.name == itr) {
                  this.allComplaintsArray[ind].selected = true;
                  this.allComplaintsArrayOg[ind].selected = true;
                }
              });
            }
          });
        }
        break;

      case 'working_diagnosis_modal':
        this.allDiagnosisArray = this.allDiagnosisArrayOg;
        if (this.allDiagnosisArray) {
          this.allDiagnosisArray.map((ins:any, ind:any) => {
            ins.selected = false;
            if (this.working_diagnosis) {
              this.working_diagnosis.split(', ').map(itr => {

                if (ins.name == itr) {
                  this.allDiagnosisArray[ind].selected = true;
                  this.allDiagnosisArrayOg[ind].selected = true;
                }
              })
            }
          });
        }
        break;

      case 'medicine_instructions_modal':
        this.allMedicineInstructionsArray = this.allMedicineInstructionsArrayOg;
        if (this.allMedicineInstructionsArray) {
          this.allMedicineInstructionsArray.map((ins, ind) => {
            ins.selected = false;
            if (this.medicine_instructions) {
              this.medicine_instructions.split(', ').map(itr => {
                if (ins.name == itr) {
                  this.allMedicineInstructionsArray[ind].selected = true;
                  this.allMedicineInstructionsArrayOg[ind].selected = true;
                }
              });
            }
          });
        }

        break;

      case 'general_instructions_modal':
        this.allGeneralInstructionsArray = this.allGeneralInstructionsArrayOg;
        if (this.allGeneralInstructionsArray.length) {
          this.allGeneralInstructionsArray.map((ins, ind) => {
            ins.selected = false;
            if (this.general_instructions) {
              this.general_instructions.split(', ').map(itr => {
                if (ins.name == itr) {
                  this.allGeneralInstructionsArray[ind].selected = true;
                  this.allGeneralInstructionsArrayOg[ind].selected = true;
                }
              });
            }
          });
        }
        break;

      case 'dietary_advices_modal':
        this.allDietaryAdvicesArray = this.allDietaryAdvicesArrayOg;
        if (this.allDietaryAdvicesArray.length) {
          this.allDietaryAdvicesArray.map((ins, ind) => {
            ins.selected = false;
            if (this.dietary_advices) {
              this.dietary_advices.split(', ').map(itr => {
                if (ins.name == itr) {
                  this.allDietaryAdvicesArray[ind].selected = true;
                  this.allDietaryAdvicesArrayOg[ind].selected = true;
                }
              });
            }
          });
        }
        break;

      case 'investigations_modal':
        this.allInvestigationsArray = this.allInvestigationsArrayOg;
        if (this.allInvestigationsArray.length) {
          this.allInvestigationsArray.map((ins:any, ind:any) => {
            ins.selected = false;
            if (this.investigations) {
              this.investigations.split(', ').map(itr => {

                if (ins.name == itr) {
                  this.allInvestigationsArray[ind].selected = true;
                  this.allInvestigationsArrayOg[ind].selected = true;
                }
              })
            }
          });
        }
        break;

      case 'more_medicine_type_modal':

        this.drugTypes = this.drugTypesOg;
        if (this.drugTypes) {
          this.drugTypes.map((ins:any, ind:any) => {
            ins.selected = false;
            if (this.investigations) {
              this.investigations.split(', ').map(itr => {
                if (ins.name == itr) {
                  this.drugTypes[ind].selected = true;
                  this.drugTypesOg[ind].selected = true;
                }
              })
            }
          });
        }
        break;

      case 'more_medicine_type_modal_new_drug':

        this.drugTypeAddNewDrugs = '';

        this.drugTypes = this.drugTypesOg;
        if (this.drugTypes.length) {


          this.drugTypes.map((ins:any, ind:any) => {
            ins.selected = false;
            if (this.drugTypeAddNewDrugs) {
              this.drugTypeAddNewDrugs.split(', ').map(itr => {

                if (ins.name == itr) {
                  this.drugTypes[ind].selected = true;
                  this.drugTypesOg[ind].selected = true;
                }
              });
            }
          });
        }
        break;

      default:
        break;
    }

    this.modalService.open(content, { backdrop: false, size: 'xl', centered: false, windowClass: 'dark-modal' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      console.log("dismissed")
    });
  }

  switchFollowup(index:any) {
    let arr = this.followupArray;
    arr.map((ins:any, ind:any) => {
      if (index == ind) {
        this.followupArray[ind].selected = false;
        this.nextFollowUp = this.nextFollowUp + "-" + ins.name;
        this.selectedFollowupStr = ins.name;
      } else {
        this.followupArray[ind].selected = false;
      }
    })
  }

  switchComplaintTabs(index:any) {
    let array = this.complaintsCardArray;
    let string = this.chief_complaints;

    array.map((ins:any, ind:any) => {
      if (ind == index) {
        array[index].selected = true;
        array[index].value = string;
        this.selectedTabComplaints = ins.name;
      } else {
        ins.selected = false;
      }
    })

  }

  switchDrugTypes(index:any) {
    let array = this.drugTypeArray;
    this.unselectedDrugType = false;
    array.map((ins:any, ind:any) => {
      if (ind == index) {
        array[index].selected = true;
        this.selectedDrugType = ins.name;
        this.selectedDosageUnit = this.dosageUnitArray[0].name
      } else {
        ins.selected = false;
      }
    });

    this.selectDosageTypeForDrugs(index);

    //Tablets
    // let dosageUnit = [{ name: "0.5", selected: true, value: "" }, { name: "1", selected: false, value: "" }, { name: "1.5", selected: false, value: "" }, { name: "2", selected: false, value: "" }, { name: "2.5", selected: false, value: "" }, { name: "3", selected: false, value: "" }, { name: "3.5", selected: false, value: "" }, { name: "4", selected: false, value: "" }];

    //Syrup
    // let dosageUnit = [{ name: "2.5", selected: true, value: "" }, { name: "3.5", selected: false, value: "" }, { name: "5", selected: false, value: "" }, { name: "10", selected: false, value: "" }];

    //Drop
    // let dosageUnit = [{ name: "5", selected: true, value: "" }, { name: "10", selected: false, value: "" }, { name: "15", selected: false, value: "" }, { name: "20", selected: false, value: "" }];

    //Capsule
    // let dosageUnit = [{ name: "1", selected: true, value: "" }, { name: "2", selected: false, value: "" }, { name: "3", selected: false, value: "" }, { name: "4", selected: false, value: "" }, , { name: "5", selected: false, value: "" }, , { name: "6", selected: false, value: "" }];

  }

  selectDosageTypeForDrugs = (index:any) => {
    let statement = this.drugTypeArray[index].name;
    //tablet - 0.5
    //capsule - 1
    //liquid - 1
    //syrup - 0.5
    //drop - 1
    //sachet - 0.5
    //vial - 0
    //apply locally - 0
    switch (statement) {
      case "Tablet":
        this.selectedIncrementNumber = 0.25;
        this.selectedDosageUnit = "0.5";
        this.doseUnitType = 'Tablet';
        this.dosageUnitArray = [{ name: "0.5", selected: true, value: "" }, { name: "1", selected: false, value: "" }, { name: "1.5", selected: false, value: "" }, { name: "2", selected: false, value: "" }, { name: "2.5", selected: false, value: "" }, { name: "3", selected: false, value: "" }, { name: "3.5", selected: false, value: "" }, { name: "4", selected: false, value: "" }];
        break;

      case "Capsule":
        this.selectedIncrementNumber = 1;
        this.selectedDosageUnit = "1";
        this.doseUnitType = 'Capsule';
        this.dosageUnitArray = [{ name: "1", selected: true, value: "" }, { name: "2", selected: false, value: "" }, { name: "3", selected: false, value: "" }, { name: "4", selected: false, value: "" }, { name: "5", selected: false, value: "" }, { name: "6", selected: false, value: "" }];
        break;

        case "Inhaler":
          this.selectedIncrementNumber = 1;
          this.selectedDosageUnit = "1";
          this.doseUnitType = 'Puff';
          this.dosageUnitArray = [{ name: "1", selected: true, value: "" }, { name: "2", selected: false, value: "" }, { name: "3", selected: false, value: "" }, { name: "4", selected: false, value: "" }, { name: "5", selected: false, value: "" }, { name: "6", selected: false, value: "" }];
          break;

        case "Injection":
          this.selectedIncrementNumber = 1;
          this.selectedDosageUnit = "1";
          this.doseUnitType = 'Injection';
          this.dosageUnitArray = [{ name: "1", selected: true, value: "" }, { name: "2", selected: false, value: "" }, { name: "3", selected: false, value: "" }, { name: "4", selected: false, value: "" }, { name: "5", selected: false, value: "" }, { name: "6", selected: false, value: "" }];
          break;

      case "Drop":
        this.selectedIncrementNumber = 1;
        this.selectedDosageUnit = "5";
        this.doseUnitType = 'Drop';
        this.dosageUnitArray = [{ name: "5", selected: true, value: "" }, { name: "10", selected: false, value: "" }, { name: "15", selected: false, value: "" }, { name: "20", selected: false, value: "" }];
        break;

      case "Syrup":
        this.selectedIncrementNumber = 0.25;
        this.selectedDosageUnit = "2.5";
        this.doseUnitType = 'ml';
        this.dosageUnitArray = [{ name: "2.5", selected: true, value: "" }, { name: "3.5", selected: false, value: "" }, { name: "5", selected: false, value: "" }, { name: "10", selected: false, value: "" }];
        break;

      case "Suspension":
      case "Liquid":
        this.selectedIncrementNumber = 1;
        this.selectedDosageUnit = "5";
        this.doseUnitType = 'ml';
        this.dosageUnitArray = [{ name: "5", selected: true, value: "" }, { name: "10", selected: false, value: "" }, { name: "15", selected: false, value: "" }, { name: "20", selected: false, value: "" }];
        break;

      case "Granules":
      case "Powder":
      case "Sachet":
        this.selectedIncrementNumber = 1;

        this.selectedDosageUnit = "1";
        this.doseUnitType = 'Sachet';
        this.dosageUnitArray = [{ name: "1", selected: true, value: "" }, { name: "2", selected: false, value: "" }, { name: "3", selected: false, value: "" }, { name: "4", selected: false, value: "" }];
        break;

      case "Vial":
        this.selectedIncrementNumber = 2.5;
        this.selectedDosageUnit = "1";
        this.doseUnitType = 'Vial';
        this.dosageUnitArray = [{ name: "2.5", selected: true, value: "" }, { name: "5", selected: false, value: "" }, { name: "10", selected: false, value: "" }, { name: "20", selected: false, value: "" }, { name: "40", selected: false, value: "" }, { name: "50", selected: false, value: "" }];

        break;

        case "Spray":
          this.selectedIncrementNumber = 1;
          this.selectedDosageUnit = "1";
          this.doseUnitType = 'Spray';
          this.dosageUnitArray = [{ name: "1", selected: true, value: "" }, { name: "2", selected: false, value: "" }, { name: "3", selected: false, value: "" }, { name: "4", selected: false, value: "" }];
          break;
      default:
        
        this.doseUnitType = this.drugTypeArray[index].name;
        this.selectedDosageUnit = 'Apply locally';
        this.dosageUnitArray = [{ name: "Apply locally", selected: true, value: "" }];

        break;
    }
  }

  switchDosageUnit(index:any) {
    this.unselectedDosageUnit = false;
    let array = this.dosageUnitArray;
    array.map((ins:any, ind:any) => {
      if (ind == index) {
        array[index].selected = true;
        this.selectedDosageUnit = ins.name;
      } else {
        ins.selected = false;
      }
    })

  }

  switchDosageType(index:any) {
    //boss
    this.unselectedDosageType = false;
    let array = this.dosageTypeArray;
    array.map((ins:any, ind:any) => {
      if (ind == index) {

        if (ins.name == 'Once a Week' || ins.name == 'Once a Month' || ins.name == 'Anytime') {
          if (ins.name == 'Once a Week') {
            this.selectedTimeType = 'Week(s)';
          }
          else if (ins.name == 'Once a Month') {
            this.selectedTimeType = 'Month(s)';
          }
          else {
            this.selectedTimeType = 'Day(s)';
          }
          this.selectedDosageType = ins.name;
          this.dosageTypeArray.map((item:any, ind:any) => {
            if (ins.name == item.name) {
              if (this.dosageTypeArray[ind].selected) {
                this.dosageTypeArray[ind].selected = false
              } else {
                this.dosageTypeArray[ind].selected = true
              }

            } else {
              item.selected = false
            }
          })
        } else {
          if (array[index].selected) {
            array[index].selected = false;
          } else {
            array[index].selected = true;
          }

          array[4].selected = false; //Once a week
          array[5].selected = false; //Once a month
          array[6].selected = false; //Anytime
          this.selectedDosageType = ins.name;
        }
      }
    });

  }

  switchWhenToTake(index:any) {
    let array = this.whenToTakeArray;
    array.map((ins:any, ind:any) => {
      if (ind == index) {
        array[index].selected = true;
        this.selectedWhenToTake = ins.name;
      } else {
        ins.selected = false;
      }
    });
  }


  switchGeneralTabs(index:any) {
    let array = this.generalCardArray;
    array.map((ins:any, ind:any) => {
      if (ind == index) {
        array[index].selected = true;
        this.selectedTabGeneral = ins.name;
      } else {
        ins.selected = false;
      }
    })

  }

  switchInvestigationTabs(index:any) {
    let array = this.investigationCardArray;
    array.map((ins:any, ind:any) => {
      if (ind == index) {
        array[index].selected = true;
        this.selectedTabInvestigation = ins.name;
      } else {
        ins.selected = false;
      }
    })

  }

  switchFollowupTab(index:any) {
    let array = this.nextFollowUpCardArray;
    array.map((ins:any, ind:any) => {
      if (ind == index) {
        array[index].selected = true;
        this.selectedTabFollowup = ins.name;
      } else {
        ins.selected = false;
      }
    })
  }

  selectModalValue(index:any, type:any) {

    switch (type) {
      case 'complaints':
        if (this.allComplaintsArray[index].selected) {
          this.allComplaintsArray[index].selected = false;
          this.allComplaintsArrayOg[index].selected = false;

          this.chief_complaints = this.chief_complaints.replace(this.allComplaintsArray[index].name + ',', '');
          this.chief_complaints = this.chief_complaints.replace(this.allComplaintsArray[index].name, '');
        } else {
          this.allComplaintsArray[index].selected = true;
        }
        break;

      case 'diagnosis':
        if (this.allDiagnosisArray[index].selected) {
          this.allDiagnosisArray[index].selected = false;
          this.allDiagnosisArrayOg[index].selected = false;

          this.working_diagnosis = this.working_diagnosis.replace(this.allDiagnosisArray[index].name + ',', '');
          this.working_diagnosis = this.working_diagnosis.replace(this.allDiagnosisArray[index].name, '');
        } else {
          this.allDiagnosisArray[index].selected = true;
        }
        break;

      case 'medicine_instructions':
        if (this.allMedicineInstructionsArray[index].selected) {
          this.allMedicineInstructionsArray[index].selected = false;
          this.allMedicineInstructionsArrayOg[index].selected = false;

          this.medicine_instructions = this.medicine_instructions.replace(this.allMedicineInstructionsArray[index].name + ',', '');
          this.medicine_instructions = this.medicine_instructions.replace(this.allMedicineInstructionsArray[index].name, '');
        } else {
          this.allMedicineInstructionsArray[index].selected = true;
        }
        break;
      case 'general_instructions':
        if (this.allGeneralInstructionsArray[index].selected) {
          this.allGeneralInstructionsArray[index].selected = false;
          this.allGeneralInstructionsArrayOg[index].selected = false;

          this.medicine_instructions = this.medicine_instructions.replace(this.allGeneralInstructionsArray[index].name + ',', '');
          this.medicine_instructions = this.medicine_instructions.replace(this.allGeneralInstructionsArray[index].name, '');
        } else {
          this.allGeneralInstructionsArray[index].selected = true;
        }
        break;

      case 'dietary_advices':
        if (this.allDietaryAdvicesArray[index].selected) {
          this.allDietaryAdvicesArray[index].selected = false;
          this.allDietaryAdvicesArrayOg[index].selected = false;

          this.medicine_instructions = this.medicine_instructions.replace(this.allDietaryAdvicesArray[index].name + ',', '');
          this.medicine_instructions = this.medicine_instructions.replace(this.allDietaryAdvicesArray[index].name, '');
        } else {
          this.allDietaryAdvicesArray[index].selected = true;
        }
        break;

      case 'investigations':
        if (this.allInvestigationsArray[index].selected) {
          this.allInvestigationsArray[index].selected = false;
          this.allInvestigationsArrayOg[index].selected = false;

          this.investigations = this.investigations.replace(this.allInvestigationsArray[index].name + ',', '');
          this.investigations = this.investigations.replace(this.allInvestigationsArray[index].name, '');
        } else {
          this.allInvestigationsArray[index].selected = true;
        }
        break;

      case 'drugTypes':
        if (this.drugTypes[index].selected) {
          this.drugTypes[index].selected = false;
          this.drugTypesOg[index].selected = false;

          // this.investigations = this.investigations.replace(this.drugTypes[index].name + ',', '');
          // this.investigations = this.investigations.replace(this.drugTypes[index].name, '');
        } else {
          // here
          // this.drugTypeArray.push({ name: this.drugTypes[index].name, selected: true, value: "" });

          this.drugTypes[index].selected = true;
          this.drugTypes.map((ins, ind) => {
            if (index != ind) {
              this.drugTypes[ind].selected = false;
            }
          })

        }
        break;

      default:
        break;
    }
  }
  selectModalFieldValue = (item:any) => {

    let data = this.selectFieldsArray;
  
    var index = data.indexOf(item);
    data[index].selected = !data[index].selected
   
    this.selectFieldsArray = data;
  }

  saveModalValues(type: string) {

    switch (type) {
      case 'complaints':
        this.allComplaintsArrayOg.map((ins:any) => {
          if (ins.selected && !this.chief_complaints.includes(ins.name)) {
            this.chief_complaints = this.chief_complaints.length ? this.chief_complaints + ', ' + ins.name : ins.name
          }
        });
        break;

      case 'diagnosis':
        this.allDiagnosisArrayOg.map((ins:any) => {
          if (ins.selected && !this.working_diagnosis.includes(ins.name)) {
            this.working_diagnosis = this.working_diagnosis.length ? this.working_diagnosis + ', ' + ins.name : ins.name
          }
        });
        break;

      case 'medicine_instructions':
        this.allMedicineInstructionsArrayOg.map((ins:any) => {
          if (ins.selected && !this.medicine_instructions.includes(ins.name)) {
            this.medicine_instructions = this.medicine_instructions.length ? this.medicine_instructions + ', ' + ins.name : ins.name
          }
        });
        break;

      case 'general_instructions':
        this.allGeneralInstructionsArrayOg.map((ins:any) => {
          if (ins.selected && !this.general_instructions.includes(ins.name)) {
            this.general_instructions = this.general_instructions.length ? this.general_instructions + ', ' + ins.name : ins.name
          }
        });
        break;

      case 'dietary_advices':
        this.allDietaryAdvicesArrayOg.map((ins:any) => {
          if (ins.selected && !this.dietary_advices.includes(ins.name)) {
            this.dietary_advices = this.dietary_advices.length ? this.dietary_advices + ', ' + ins.name : ins.name
          }
        });
        break;

      case 'investigations':
        this.allInvestigationsArrayOg.map((ins:any) => {
          if (ins.selected && !this.investigations.includes(ins.name)) {
            this.investigations = this.investigations.length ? this.investigations + ', ' + ins.name : ins.name
          }
        });
        break;

      case 'drugTypes':
        this.drugTypes.map((ins:any, index:any) => {
          if (ins.selected) {
            this.drugTypeAddNewDrugs = ins.name
          }
        });

        let cond = true;
        let selectedInd = '';
        this.drugTypeArray.map((ins:any, ind:any) => {
          ins.selected = false;
          if (ins.name == this.drugTypeAddNewDrugs) {
            ins.selected = true;
            this.selectedDrugType = ins.name;
            this.selectDosageTypeForDrugs(ind);
            cond = false;
            selectedInd = ind;
          }
        })

        if (cond) {
          this.selectedDrugType = this.drugTypeAddNewDrugs;

          // this.drugTypeArray.push({ name: this.drugTypeAddNewDrugs, selected: true, value: "" });
          this.drugTypeArray.splice(this.drugTypeArray.length - 1, 0, { name: this.drugTypeAddNewDrugs, selected: true, value: "" });

          this.doseUnitType = this.drugTypeAddNewDrugs;
          this.selectDosageTypeForDrugs(this.drugTypeArray.length - 2);
        }


        break;

      case 'drugTypesAddNewDrug':
        this.addNewDrugs();


        break;

      case 'copyMedicines':
        // this.selectedPreviousMed = medArr[0].medicine;
        // this.selectedPreviousMedDate = medArr[0].value;
        this.selectedPreviousMed.map((ins:any) => {
          ins.id = null;
          ins.medicineName = ins.Drug.product_name;
        })
        // this.selectedFavMed.map(ins=>{
        //   ins.id = null;
        //   ins.medicineName = ins.Drug.product_name;
        // })
        this.prescriptionPreviewArray = [...this.selectedPreviousMed, ...this.prescriptionPreviewArray];
        this.medicine_list = [...this.selectedPreviousMed, ...this.medicine_list]
        // this.prescriptionPreviewArray = [...this.selectedFavMed, ...this.prescriptionPreviewArray];
        // this.medicine_list = [...this.selectedFavMed, ...this.medicine_list]
        break;
      case 'copyMedicinesFav':
        // this.selectedPreviousMed = medArr[0].medicine;
        // this.selectedPreviousMedDate = medArr[0].value;

        this.selectedFavMed.map((ins:any) => {
          ins.id = null;
          ins.medicineName = ins.Drug.product_name;
        })

        this.prescriptionPreviewArray = [...this.selectedFavMed, ...this.prescriptionPreviewArray];
        this.medicine_list = [...this.selectedFavMed, ...this.medicine_list]
        break;

      default:
        break;
    }


  }

  removeMedicineFromPreview = (index:any) => {
    // alert(JSON.stringify(this.medicine_list[index]))
    let obj = this.prescriptionPreviewArray[index];
    this.deletedMedicineArr.push(obj.id);
    this.prescriptionPreviewArray.splice(index, 1);
    this.medicine_list.splice(index, 1);

  }

  addNewDrugs = () => {
    // this.drugCompanyAddNewDrugs = '';
    // this.genericDrugNameAddNewDrugs = '';
    // this.drugTypeAddNewDrugs = '';
    // this.drugNameAddNewDrugs = '';

    const numbers = [1, 2, 3, 4, 5, 6, 7, 8, 9];
    let otp = "";
    for (let i = 0; i < 4; i++) {
      //chenged to 6 from 4
      otp += numbers[Math.floor(Math.random() * 8) + 1];
    }
    var obj = {
      "product_name": this.drugNameAddNewDrugs,
      "product_company": this.drugCompanyAddNewDrugs,
      "product_type": this.drugTypeAddNewDrugs,
      "product_composition": this.genericDrugNameAddNewDrugs,
      "product_id": `${this.drugNameAddNewDrugs.substring(0, 3).trim() + otp}`
    }

    this.patientService.addNewDrug(obj).subscribe((result:any) => {
      if (result.Drug) {
        console.log('Saved New Drug');
        this.searchedMeds=result.Drug;
        console.log("newDrug",this.searchedMeds)
        this.drugCompanyAddNewDrugs = '';
        this.genericDrugNameAddNewDrugs = '';
        this.drugTypeAddNewDrugs = '';
        this.drugNameAddNewDrugs = '';
      } else {
        alert('Something went wrong');
      }
    });
  }

  onDateSelect = (date:any, type:any) => {
    let selectedDate = `${date.day}-${date.month}-${date.year}`
    if (type == 1) {
      this.nextFollowUp = this.nextFollowUp && this.nextFollowUp.length ? selectedDate + ': ' + this.nextFollowUp : selectedDate + ':'
    } else {
      this.prescriptionExpirationDate = this.prescriptionExpirationDate.length ? selectedDate + ': ' + this.prescriptionExpirationDate : selectedDate + ": "
    }

  }

  onSearchChange(searchValue: string, type: string): void {

    let data = [];
    let newData = [];

    switch (type) {
      case 'complaints':
        data = this.allComplaintsArrayOg;
        break;

      case 'diagnosis':
        data = this.allDiagnosisArrayOg;
        break;

      case 'medicine_instructions':
        data = this.allMedicineInstructionsArrayOg;
        break;

      case 'general_instructions':
        data = this.allGeneralInstructionsArrayOg;
        break;

      case 'dietary_advices':
        data = this.allDietaryAdvicesArrayOg;
        break;

      case 'investigations':
        data = this.allInvestigationsArrayOg;
        break;

      case 'investigations':
        data = this.drugTypesOg;
        break;

      case 'drugTypes':
        data = this.drugTypesOg;
        console.log("drugtype",data)
        break;

      default:
        break;
    }

    if (searchValue.length) {
      newData = data.filter((item:any) => {
        return item.name.toLowerCase().includes(searchValue.toLowerCase())
      });
    } else {
      newData = data;
    }


    switch (type) {
      case 'complaints':
        this.allComplaintsArray = newData;
        break;

      case 'diagnosis':
        this.allDiagnosisArray = newData;
        break;

      case 'medicine_instructions':
        this.allMedicineInstructionsArray = newData;
        break;

      case 'general_instructions':
        this.allGeneralInstructionsArray = newData;
        break;
      case 'dietary_advices':
        this.allDietaryAdvicesArray = newData;
        break;
      case 'investigations':
        this.allInvestigationsArray = newData;
        break;

      case 'drugTypes':
        data = this.drugTypes = newData;
        break;

      default:
        break;
    }
 

  }


  getAllDoctorPrescriptions = () => {

    var obj = {
      "patientId": this.patientId,
      "isForHistory": true,
    }

    this.patientService.getAppointmentsByPatientId(obj).subscribe((response:any) => {
      const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
      if (response.success) {
        console.log("mmm1", response)
        if (response.historyArr.length) {

          var medArr = [];
          var arr = [];
          for (let index = 0; index < response.historyArr.length; index++) {
            const element = response.historyArr[index];
            var obj: any = {}
            obj.createdAt = element.from;
            obj.from = element.from;
            obj.to = element.to;
            obj.id = element.id;
            obj.favApptName = element.favApptName;
            obj.docName = element.Doctor.User.first_name + " " + element.Doctor.User.last_name;
            obj.Visit = element.Visit && element.Visit != null ? element.Visit : null;
            obj.Medicines = element.Visit && element.Visit != null ? element.Visit.Medicines && element.Visit.Medicines.length > 0 ? element.Visit.Medicines : null : null;
            obj.prescriptionPDFURL = element.prescriptionPDFURL && element.prescriptionPDFURL != null ? element.prescriptionPDFURL : null;
            obj.Certificates = element.Certificates && element.Certificates != null ? element.Certificates : null;
            if (element.Visit && element.Visit != null && element.Visit.Medicines && element.Visit.Medicines.length > 0) {
              var med: any = {};
              med.value = `${days[new Date(element.from).getDay()]}, ${moment(element.from).format('DD MMM YYYY')}`
              med.medicine = element.Visit.Medicines;
              medArr.push(med);
            }

            arr.push(obj);

          }

          if (medArr.length > 0) {
            this.previousMedsArr = medArr.reverse();
            this.selectedPreviousMed = medArr[0].medicine;

            this.selectedPreviousMedDate = medArr[0].value;
            // this.selectedPreviousFavMed=medArr[0].favApptName

            this.selectedPreviousMed.map((ins:any) => {
              if (ins.Drug) {
                ins.dosage2 = ins.duration2 ? ins.dosage2.replace('--', `- ${ins.duration2} -`) : ins.dosage2;
                ins.medicineName = ins.Drug.product_name;
              }
            })
          }
        }

        // if (response.data.historyArr.length > 0) {
        //   var medArr = [];
        //   for (let index = 0; index < response.data.historyArr.length; index++) {
        //     const element = response.data.historyArr[index];
        //     var obj = {}
        //     obj.createdAt = element.from;
        //     obj.from = element.from;
        //     obj.to = element.to;
        //     obj.id = element.id;
        //     obj.docName = element.Doctor.User.first_name + " " + element.Doctor.User.last_name;
        //     obj.Visit = element.Visit && element.Visit != null ? element.Visit : null;
        //     obj.Medicines = element.Visit && element.Visit != null ? element.Visit.Medicines && element.Visit.Medicines.length > 0 ? element.Visit.Medicines : null : null;
        //     obj.prescriptionPDFURL = element.prescriptionPDFURL && element.prescriptionPDFURL != null ? element.prescriptionPDFURL : null;
        //     obj.Certificates = element.Certificates && element.Certificates != null ? element.Certificates : null;
        //     if (element.Visit && element.Visit != null && element.Visit.Medicines && element.Visit.Medicines.length > 0) {
        //       var med = {};
        //       med.value = `${days[new Date(element.from).getDay()]}, ${moment(element.from).format('DD MMM YYYY')}`
        //       med.medicine = element.Visit.Medicines;
        //       medArr.push(med);
        //     }

        //     arr.push(obj);

        //   }

        //   if (medArr.length > 0) {
        //     this.setState({ previousMedsArr: medArr.reverse() }, () => {
        //       this.setState({
        //         selectedPreviousMed: medArr[0].medicine,
        //         selectedPreviousMedDate: medArr[0].value
        //       })
        //     })
        //   }

        // }


      }
    });
  }

  clearAllSelection = () => {
    this.drugTypeArray.map(ins => ins.selected = false);
    this.dosageUnitArray.map(ins => ins.selected = false);
    this.dosageTypeArray.map(ins => ins.selected = false);
    this.whenToTakeArray.map(ins => ins.selected = false);
    this.yourtext = "";
    this.medicine_instructions = "";
    this.days = "";
    this.selectedDosageUnit = "";
    this.selectFieldsArray.map(ins => ins.selected = true)
  }

  validate = () => {

    if (Object.keys(this.selectedMedicineObject).length === 0) {
      this.unselectedDrugName = true;
    }

    if (this.selectedDrugType == "") {
      this.unselectedDrugType = true;
    }

    if (this.selectedDosageUnit == "") {
      this.unselectedDosageUnit = true;
    }

    if (this.selectedDosageType == "") {
      this.unselectedDosageType = true;
    }


    if (!this.days.length) {
      this.unselectedDays = true;
    }
    // if(this.templateName==""){
    //   this.unselectedTemplateName=true;
    // }

  }

  onDaysChange = (val:any) => {

    setTimeout(() => {
      let isnum = /^\d+$/.test(val);
      if (isnum) {
        this.days = val;
      } else {
        this.days = "";
      }
    }, 200
    );


    this.unselectedDays = false;
  }

  onChangeDrugName = () => {
    this.unselectedDrugName = false;
  }

  getPrescription() {

    var obj = {
      "patientId": this.patientId,
      "selectfield": this.selectFieldsArray
    }

    this.patientService.getPrescriptions(obj).subscribe((response:any) => {

      if (response) {
        console.log("Prescription response", response);
        // alert('Response --- ' + JSON.stringify(response));
        if (response.appointment) {
          this.isEditPrescription = true;
          this.appointmentData = response.appointment;
          this.appointmentId = response.appointment.id;
          this.medicineArry=response.visit.Medicines;
          console.log("appiis", this.appointmentId)

        }

        if (response.visit) {

          this.chief_complaints = response.visit.chief_complaints ? response.visit.chief_complaints : '';
          this.working_diagnosis = response.visit.complaint_diagnosis ? response.visit.complaint_diagnosis : '';
          this.general_instructions = response.visit.general_instruction ? response.visit.general_instruction : '';
          this.dietary_advices = response.visit.nutrition_diet_advice ? response.visit.nutrition_diet_advice : '';
          // this.investigations = response.visit.suggested_investigation;
          // this.medicine_instructions = '';
          this.nextFollowUp = response.visit.next_vaccination;

          let data:any = response.visit.Medicines;

          data.map((ins:any) => {

            let obj: any = {}
            obj.Drug = ins.Drug;
            obj.dosagePreviewMed = ins.dosage2;
            obj.dosage2 = ins.dosage2;
            obj.duration2 = ins.duration2
            obj.duration3 = ''//this.days;
            obj.duration4 = ins.frequency2;
            obj.finalPreview = ins.dosage2;
            obj.frequency2 = ins.frequency2;
            obj.instructions = ins.instructions;
            obj.id = ins.id;

            let element = {
              // drugType: this.selectedDrugType,
              // dose: this.selectedDosageUnit,
              // time: timeArr.join(', '),
              whenToTake: ins.duration2,
              // days: this.days,
              medicineName: ins.Drug.product_name,
              dosage2: ins.dosage2,
              instructions: ins.instructions,
              id: ins.id,
              //  favApptName:ins.favApptName
            }

            element.dosage2 = element.whenToTake ? element.dosage2.replace('--', `- ${element.whenToTake} -`) : element.dosage2

            // ins.dosage2 = ins.duration2 ? ins.dosage2.replace('--', `- ${ins.duration2} -`) : ins.dosage2;

            //here
            this.medicine_list.push(obj);
            this.prescriptionPreviewArray.push(element);
            // this.favArry.push(element);
          });



        }


      }
    });

    // var obj = { patientId: this.props.navigation.state.params.patient._id }
    // httpCall("POST", `v1/getPrescriptions`, obj)
    //   .then((result) => {
    //     if (result.data.message === "No appointment today") {
    //     } else {
    //       var current_prescription = result.data.visit;
    //       console.log(">>>>>>>>>>.", JSON.stringify(result.data.visit));
    //       this.setState({
    //         instructionsText: current_prescription.general_instruction && current_prescription.general_instruction != null ? current_prescription.general_instruction : '',
    //         suggestedInvestigation: current_prescription.suggested_investigation && current_prescription.suggested_investigation != null ? current_prescription.suggested_investigation : '',
    //         complaintsText: current_prescription.chief_complaints && current_prescription.chief_complaints != null ? current_prescription.chief_complaints : '',
    //         nextFollowUpStr: current_prescription.next_vaccination && current_prescription.next_vaccination != null ? current_prescription.next_vaccination : '',
    //         expirationDateStr: current_prescription.expirationDate && current_prescription.expirationDate != null ? current_prescription.expirationDate : '',
    //         diagnosisText: current_prescription.complaint_diagnosis && current_prescription.complaint_diagnosis != null ? current_prescription.complaint_diagnosis : '',
    //         dietText: current_prescription.nutrition_diet_advice && current_prescription.nutrition_diet_advice != null ? current_prescription.nutrition_diet_advice : '',
    //         medicine_list: current_prescription.Medicines && current_prescription.Medicines.length > 0 ? current_prescription.Medicines : [],
    //       })
    //     }

    //   })
    //   .catch((error:any) => {
    //     console.warn(error);
    //     if (error.request.status === 0) {
    //       Alert.alert(
    //         'Connection Unavailable',
    //         'Check your internet connection and try again.',
    //         [
    //           { text: 'OK', onPress: () => { } },               //TODO  call this api again?
    //         ],
    //         { cancelable: false }
    //       )
    //     }
    //   });
  }
  getFavApptsOfDoctor = () => {
    // this.showRequisitionLoading = true;
    this.patientService.getFavApptsOfDoctor().subscribe((response:any) => {
      if (response) {
        // this.currentFavMedObj=response;
        this.favArry = [];
        this.selectedFavMed = [];

        //let myid=this.currentFavMedObj.id;
        // this.selectedFavMed=response;
        console.log("favappt", this.currentFavMedObj)
        // this.showRequisitionLoading = false;
        for (let ins = 0; ins < response.length; ins++) {

          const element = response[ins];
          var obj: any = {}


          obj.Medicines = element.Visit && element.Visit != null ? element.Visit.Medicines && element.Visit.Medicines.length > 0 ? element.Visit.Medicines : null : null;
          if (element.Visit && element.Visit != null && element.Visit.Medicines && element.Visit.Medicines.length > 0) {
            var med: any = {};
            med.id = element.id;
            med.value = element.favApptName;
            med.medicine = element.Visit.Medicines;

            this.favArry.push(med);
          }

          // this.favArry.push(this.selectedFavMed[ins].favApptName);
          //this.favArry.push(obj)

        }
        console.log("favArrar", this.favArry);
        // this.selectedFavMed.map(ins=>{
        //   if (ins.Drug) {
        //     ins.dosage2 = ins.duration2 ? ins.dosage2.replace('--', `- ${ins.duration2} -`) : ins.dosage2;
        //     ins.medicineName = ins.Drug.product_name;
        //   }

        // })
        // this.selectedPreviousFavMed="choose"

        if (this.favArry.length > 0) {
          this.selectedFavMed = this.favArry[0].medicine

          this.selectedPreviousFavMed = this.favArry[0].value;

        }
        // if (response.visit) {
        //   this.chief_complaints = response.visit.chief_complaints ? response.visit.chief_complaints : '';
        //   this.working_diagnosis = response.visit.complaint_diagnosis ? response.visit.complaint_diagnosis : '';
        //   this.general_instructions = response.visit.general_instruction ? response.visit.general_instruction : '';
        //   this.dietary_advices = response.visit.nutrition_diet_advice ? response.visit.nutrition_diet_advice : '';


        // }
        console.log("sele", this.selectedFavMed)



        this.selectedFavMed.map(ins => {

          console.log("logggg", ins.value)
          if (ins.Drug) {
            ins.dosage2 = ins.duration2 ? ins.dosage2.replace('--', `- ${ins.duration2} -`) : ins.dosage2;
            ins.medicineName = ins.Drug.product_name;
          }
        })


      }
    })
  }

  closefavper() {
    this.selectedPreviousFavMed = "choose"
    this.selectedFavMed = [];



  }
  onClickDeleteeFavMed(favobj:any) {
    this.currentFavMedObj = favobj;


  }
  
  onClickDeleteFavMed() {
    console.log("favId", this.currentFavMedObj);

    let postData = {
      appointmentId: this.currentFavMedObj.id
    }
    this.patientService.removeFavApptOfDoctor(postData).subscribe((response:any) => {
      // if (confirm("Are you sure to delete ")) {
      console.log("delete", response);

      this.getFavApptsOfDoctor();
      this.modalService.dismissAll();



      //}

      //   this.getFavApptsOfDoctor();
    });

  }
  getDoctorDetails = () => {
    let params = {
      user_id: this.userId
    }
    this.doctorService.getDetails(params).subscribe((response:any) => {
      console.log('Doctor Response', response.doctor)
      //  this.currentDoctorObj = response.doctor
      if (response.success) {
        if (response.doctor.services && response.doctor.services !== null) {
          var services = JSON.parse(response.doctor.services);
          // this.selectedTemplate=JSON.parse(response.doctor.ser)

          if (services.template_names) {
            // this.tabs.push('Receipts');
            this.templateName = 'Speciality';
            this.selectedTemplate = services.template_names;

          }
          else {
            this.selectedTemplate.push('default');
          }
        }
        else {
          this.templateName = 'default';
          this.selectedTemplate.push('default');
        }
      }
    })
  }


  previewPrescriptionPDF = () => {
    console.log("med",this.medicine_list)
    this.validate();
    if (this.templateName == "Speciality") {
     
      this.messageService.add({ severity: 'custom', detail: 'Please specify speciality before proceeding' });


    }
    else {
      let followupAddOn = '';
      this.followupArray.map((ins:any) => {
        if (ins.selected) {
          followupAddOn = ' - ' + ins.name
        }

      })
      // let whenTotake='';
      // this.whenToTakeArray.map(ins=>{
      //   if(ins.selected){
      //     whenTotake=' - '+ins.name
      //   }
      // })
      this.showLoading = true;
      let obj: any = {};
      var patient: any = {};

      if (this.isEditPrescription) {

        var patient = this.patient;
        patient.first_name = this.patient.firstName;
        patient.last_name = this.patient.lastName;
        patient.gender = this.patient.gender;
        patient.phone_number = this.patient.contactNo;
        patient.age = this.patient.age;
        patient.weight = 'N/A';
        patient.height = 'N/A';

        obj = {
          "visit_id": this.appointmentData.VisitId,
          "clinic_id": null,
          "read_only": false,
          "date": this.appointmentData.visit_date,
          "appointmentId": this.appointmentData.id,
          "action": "preview",
          "patientId": this.patientId,
          "patient": patient,
          "medicines": this.medicine_list,
          "general_instruction": this.general_instructions,
          "covidQues": null,
          "suggested_investigation": this.investigations,
          "chief_complaints": this.chief_complaints,
          "next_vaccination": this.nextFollowUp,
          "expirationDate": this.prescriptionExpirationDate,
          "chief_complaint": this.chief_complaints,
          "on_examination": "N/A",
          "complaint_diagnosis": this.working_diagnosis,

          "savePrescriptionParams": {},
          "deletedMedicines": this.deletedMedicineArr,
          'newVersion': true,
          "medicinePreview": '',//pending
          "language": this.selectedLanguage.language,
          "nutrition_diet_advice": this.dietary_advices,
          "templateName": this.templateName,
        };

      } else {
        patient.first_name = this.patient.firstName;
        patient.last_name = this.patient.lastName;
        patient.gender = this.patient.gender;
        patient.phone_number = this.patient.contactNo;
        patient.age = this.patient.age;
        patient.weight = 'N/A';
        patient.height = 'N/A';

        obj = {
          "visit_id": null,
          "clinic_id": null,
          "read_only": false,
          "date": null,
          "appointmentId": null,
          "action": "preview",
          "patientId": this.patientId,
          "patient": patient,
          "medicines": this.medicine_list, //pending
          "general_instruction": this.general_instructions,
          "covidQues": "",
          "suggested_investigation": this.investigations,
          "chief_complaints": this.chief_complaints,
          "next_vaccination": this.nextFollowUp + followupAddOn,
          "expirationDate": this.prescriptionExpirationDate,
          "on_examination": "N/A",
          "complaint_diagnosis": this.working_diagnosis,
          "savePrescriptionParams": {},
          "deletedMedicines": this.deletedMedicineArr,//pending
          'newVersion': true,
          "medicinePreview": '',//pending
          "language": this.selectedLanguage.language,
          "nutrition_diet_advice": this.dietary_advices,
          "templateName": this.templateName,
        }

      }
    //   this.medicine_list + whenTotake;
      this.medicine_list.map(ins => {
        // ins.dosage2 = ins.dosage2.replaceAll(',', ' - ')
        ins.dosage2 = ins.dosage2.split(",").join(" - ");
        ins.finalPreview = ins.dosage2
      })

      let savePrescriptionParams = {
        visit: {
          complaint_diagnosis: obj.complaint_diagnosis,
          general_instruction: obj.general_instruction,
          chief_complaints: obj.chief_complaints,
          next_vaccination: obj.next_vaccination,
          suggested_investigation: obj.suggested_investigation,
         covidQues: null as string | null,
          expirationDate: obj.expirationDate,
          nutrition_diet_advice: obj.nutrition_diet_advice,
        },
        patient_id: obj.patientId,
        visit_id: obj.visit_id,
        medicine_list: this.medicine_list,
        deleted_medicines: obj.deletedMedicines,
      };
      obj.savePrescriptionParams = savePrescriptionParams;
      var arr = this.selectFieldsArray.filter(field => { if (field.selected) { return field } });
      arr = arr.map(field => { return field.value });
      obj.printingFields = arr;
      //obj.templete
      console.log("RETRO>>>>>>", JSON.stringify(obj));

      this.prescriptionPreviewArray = [];
      //this.selectFieldsArray=[];
      this.medicine_list = [];
      // this.printingFields='';
      if (this.isEditPrescription) {
        this.patientService.printPrescription(obj).subscribe((response:any) => {
          if (response) {
            this.showLoading = false;
            console.log('PRESCRIPTION PDF Version 1', response)
            let url = response.url;
            //window.open(url);
            sessionStorage.setItem("currentPreviewPrescriptionObject", JSON.stringify(obj));
            this.router.navigate([`/doctor/patients/prescriptions/preview`], { queryParams: { prescrip_url: url, patientId: this.patientId } });
          } else {
            this.showLoading = false;
          }
        });
      } else {
        this.patientService.printPrescriptionVersion2(obj).subscribe((response:any) => {
          if (response) {
            this.showLoading = false;
            console.log('PRESCRIPTION PDF Version 2', response)
            let url = response.url;
            //window.open(url);
            sessionStorage.setItem("currentPreviewPrescriptionObject", JSON.stringify(obj));
            this.router.navigate([`/doctor/patients/prescriptions/preview`], { queryParams: { prescrip_url: url, patientId: this.patientId } });
          } else {
            this.showLoading = false;
          }
        });
      }


    }
  }
}
